import styled from '@emotion/styled';

const InfoWrapper = styled('section')({
  paddingRight: 16,
  display: 'flex',
  alignItems: 'center',
});

export default InfoWrapper;
